// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__y10lc","image":"ProjectCard_image__dPr4B","info":"ProjectCard_info__Sce6U","links":"ProjectCard_links__lkLeg","button":"ProjectCard_button__4QtQT"};